import { NB } from '@cerebral-inc/ui';
import SemiCircleProgress from './SemiCircleProgress';
import { ADHD_MAX_SCORE, ADHD_SCORES } from './constants/score';

const { Flex, Text } = NB;

interface ScoreProps {
  score: number;
}

const Score = ({ score }: ScoreProps) => {
  const getSeverity = () => {
    return (
      ADHD_SCORES.find(range => score >= range.min && score <= range.max)
        ?.text || ''
    );
  };

  return (
    <Flex
      bgColor="#250044"
      w="100%"
      py={{ base: '64px', lg: '96px' }}
      alignItems="center"
    >
      <Flex
        maxW={{ base: '100%', lg: '1264px' }}
        h={{ base: 'auto', lg: '220px' }}
        flexDir={{ base: 'column', lg: 'row' }}
        justifyContent="space-between"
        alignItems="center"
        px="24px"
      >
        <Flex
          justifyContent="center"
          alignItems={{ base: 'center', lg: 'flex-start' }}
          w={{ base: '100%', lg: 'calc(100% - 400px - 12vw)' }}
        >
          <Text
            fontFamily="Poppins"
            color="#FFFFFF"
            fontSize={{ base: '28px', sm: '32px' }}
            fontWeight={600}
            lineHeight={{ base: '30px', sm: '40px' }}
            textAlign={{ base: 'center', lg: 'left' }}
          >
            {`Your score is: `}
            <Text color="#C7BFFF">{score}</Text>
          </Text>
          <Text
            mt="20px"
            color="#FAFAFC"
            fontFamily="Poppins"
            fontSize="16px"
            lineHeight="24px"
            textAlign={{ base: 'center', lg: 'left' }}
          >
            Experiencing symptoms is a common occurrence. Discover ways to
            manage and reduce symptoms through Cerebral.
          </Text>
        </Flex>
        <Flex
          w={{ base: '100%', sm: '400px' }}
          justifyContent="center"
          alignItems="center"
          mt={{ base: '80px', lg: 0 }}
        >
          <SemiCircleProgress
            score={score}
            severity={getSeverity()}
            percentage={Math.round((score / ADHD_MAX_SCORE) * 100)}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Score;
